export default class HelperPhone {
  static digitsOnly = (phone: string): string => phone.replace(/\D/g, "");

  static build = (phone: string): { ddd: string; number: string } => {
    let digits = HelperPhone.digitsOnly(phone);

    // remove código do país (55) se presente: 12 = 55 + DDD + 8 / 13 = 55 + DDD + 9
    if ((digits.length === 12 || digits.length === 13) && digits.startsWith("55")) {
      digits = digits.slice(2);
    }

    const hasDDD = digits.length >= 10;
    return {
      ddd: hasDDD ? digits.slice(0, 2) : "",
      number: hasDDD ? digits.slice(2) : digits,
    };
  };

  static extractDDD = (phone: string): string => HelperPhone.build(phone).ddd;

  static extractNumber = (phone: string): string => HelperPhone.build(phone).number;
}
